import { useReveal } from "../hooks/useReveal";
import { Quote, CheckCircle2 } from "lucide-react";

const CEO_IMAGE =
  "https://customer-assets.emergentagent.com/job_premium-real-estate-17/artifacts/h5qgtin4_founde%20ceo.jpeg";

const HIGHLIGHTS = [
  "High Rental Yield",
  "Tax-Free Investment Environment",
  "Fast-Growing Global Market",
  "Premium Residential & Commercial Opportunities",
];

export const Founder = () => {
  const ref = useReveal();
  return (
    <section
      id="founder"
      data-testid="founder-section"
      className="relative py-28 md:py-36 px-6 md:px-12 bg-[#050a18] overflow-hidden"
    >
      <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full bg-[#c5a059]/10 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto relative">
        <div className="text-[10px] tracking-[0.5em] text-[#c5a059] uppercase mb-6">
          02.5 · Founder&apos;s Message
        </div>
        <h2 className="font-serif-display text-4xl md:text-6xl font-light leading-tight max-w-3xl mb-16">
          A vision beyond <span className="italic gold-gradient">real estate</span>
        </h2>

        <div ref={ref} className="reveal grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Portrait */}
          <div className="lg:col-span-5 relative" data-testid="founder-portrait">
            <div className="relative aspect-[4/5] overflow-hidden rounded-2xl">
              <img
                src={CEO_IMAGE}
                alt="Varachandra Nanda, Founder & CEO"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-[#c5a059]/30 rounded-2xl pointer-events-none" />
            </div>
            {/* Decorative frame */}
            <div className="absolute -bottom-5 -right-5 w-full h-full border border-[#c5a059]/40 rounded-2xl -z-10 hidden md:block" />

            {/* Name plate */}
            <div className="mt-6 glass rounded-xl p-5">
              <div className="font-serif-display text-2xl">Varachandra Nanda</div>
              <div className="text-[10px] tracking-[0.35em] text-[#c5a059] uppercase mt-2">
                Founder &amp; CEO · Universal Dream Properties LLC
              </div>
            </div>
          </div>

          {/* Message */}
          <div className="lg:col-span-7" data-testid="founder-message">
            <Quote className="text-[#c5a059] mb-6" size={40} strokeWidth={1} />
            <blockquote className="font-serif-display text-xl md:text-2xl leading-relaxed text-white/90 italic">
              Dubai continues to redefine global real estate with strong rental returns,
              investor-friendly policies, and rapid infrastructure growth. From luxury residences
              to commercial investments, the city offers exceptional opportunities for long-term
              wealth creation.
              <br />
              <br />
              At Universal Dream Properties LLC, our mission is to connect investors with
              high-potential properties backed by market expertise, transparency, and trust. We
              believe Dubai is not just a destination to invest —{" "}
              <span className="gold-gradient not-italic font-semibold">
                it is a destination to grow.
              </span>
            </blockquote>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {HIGHLIGHTS.map((h) => (
                <div
                  key={h}
                  className="flex items-center gap-3 glass rounded-lg px-4 py-3"
                  data-testid={`founder-highlight-${h.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  <CheckCircle2 size={16} className="text-[#c5a059] shrink-0" />
                  <span className="text-sm text-white/85">{h}</span>
                </div>
              ))}
            </div>

            <div className="mt-10 pt-8 border-t border-white/10">
              <p className="font-serif-display text-2xl md:text-3xl italic gold-gradient">
                &ldquo;Your Dream Investment Begins Here.&rdquo;
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
